/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type UserConversationLengthFilterConfigColumn =
  (typeof UserConversationLengthFilterConfigColumn)[keyof typeof UserConversationLengthFilterConfigColumn];

export const UserConversationLengthFilterConfigColumn = {
  user_conversation_length: 'user_conversation_length',
} as const;
